<template>
  <v-form ref="form" v-model="valid" lazy-validation class="full">
    <v-col class="md-hidden pager-row">
      <span class="back-button" @click="goBack">
        <i class="fas fa-chevron-left m-r-5"></i>
        Go Back
      </span>
      <radial-progress-bar
        :diameter="45"
        :completed-steps="completedSteps"
        :total-steps="totalSteps"
        :startColor="'#00A8C8'"
        :stopColor="'#00A8C8'"
        :innerStrokeColor="'#B0E5EF'"
        :strokeWidth="3"
        :innerStrokeWidth="3"
        class="right progress-bar"
      >
        <p>
          <span>{{ completedSteps }}</span> of {{ totalSteps }}
        </p>
      </radial-progress-bar>
    </v-col>
    <v-col cols="12" class="col-md-8 alert-div-wrapper">
      <div class="alert-div">
        Please ensure all the information below is correct. Once all the
        information has been verified, you can print a copy of this page within
        your browser for your reference before moving on to the next page.
      </div>
    </v-col>

    <div class="form-body col-md-8 col-12 m-t-0">
      <v-container class="confirm-container">
        <!-- Personal Information Section -->

        <v-col cols="12" sm="12" md="12" class="confirm-header header-div">
          <span class="heading-text">Personal Information</span>
          <span class="pencil-icon" @click="goToPage(1)"></span>
        </v-col>

        <v-row class="form-item-section">
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Name of yacht owner
            </v-list-item-title>
            <p>
              {{ formDetails.proposer_detail.name }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Personal I.D. Card or Certificate of Business Registration of the
              Yacht Owner(s)
            </v-list-item-title>
            <p>
              {{ formDetails.proposer_detail.id }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Yacht owner's nationality
            </v-list-item-title>
            <p>
              {{ formDetails.proposer_detail.nationality }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Contact phone number
            </v-list-item-title>
            <p>
              +{{ formDetails.proposer_detail.phone_country_code }}
              {{ formDetails.proposer_detail.phone }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Email
            </v-list-item-title>
            <p>
              {{ formDetails.proposer_detail.email }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Country
            </v-list-item-title>
            <p>
              {{
                getDropdownValue(formDetails.proposer_detail.country, "country")
              }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Address
            </v-list-item-title>
            <p>
              {{ formatAddress() }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Owner's business nature / occupation
            </v-list-item-title>
            <p>
              {{ formDetails.proposer_detail.business_nature }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Mortgagees (if any)
            </v-list-item-title>
            <p>
              {{ formDetails.proposer_detail.mortgagees }}
            </p>
          </v-col>
        </v-row>

        <!-- Yacht Information Section -->

        <v-col cols="12" sm="12" md="12" class="confirm-header header-div">
          <span class="heading-text">Yacht Information</span>
          <span class="pencil-icon" @click="goToPage(2)"></span>
        </v-col>

        <v-row class="form-item-section">
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Type of yacht
            </v-list-item-title>
            <p>
              {{
                getDropdownValue(
                  formDetails.yacht_detail.yacht_hull_type,
                  "yacht_hull_type"
                )
              }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Type of yacht
            </v-list-item-title>
            <p>
              {{
                getDropdownValue(
                  formDetails.yacht_detail.yacht_power_type,
                  "yacht_power_type"
                )
              }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Name of yacht
            </v-list-item-title>
            <p>
              {{ formDetails.yacht_detail.name }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Year built
            </v-list-item-title>
            <p>
              {{ formDetails.yacht_detail.year_built }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Licensing office / port of registry
            </v-list-item-title>
            <p>
              {{ formDetails.yacht_detail.licensing_office }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              License / registration No. / IMO No.
            </v-list-item-title>
            <p>
              {{ formDetails.yacht_detail.license_no }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Builders
            </v-list-item-title>
            <p>
              {{ formDetails.yacht_detail.builders }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Model
            </v-list-item-title>
            <p>
              {{ formDetails.yacht_detail.model }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Material of hull
            </v-list-item-title>
            <p>
              {{
                formDetails.yacht_detail.material_hull === "OTH"
                  ? formDetails.yacht_detail.material_hull_other
                  : getDropdownValue(
                      formDetails.yacht_detail.material_hull,
                      "hull_material"
                    )
              }}
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            class="input-wrapper confirm-section"
            v-if="formDetails.yacht_detail.yacht_power_type === 'SY'"
          >
            <v-list-item-title>
              Material of mast, rigging and sails
            </v-list-item-title>
            <p>
              {{
                formDetails.yacht_detail.material_mast === "OTH"
                  ? formDetails.yacht_detail.material_mast_other
                  : getDropdownValue(
                      formDetails.yacht_detail.material_mast,
                      "myst_material"
                    )
              }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Length (m)
            </v-list-item-title>
            <p>
              {{ formDetails.yacht_detail.length }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Beam (m)
            </v-list-item-title>
            <p>
              {{ formDetails.yacht_detail.beam }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Gross Tonnage (tons)
            </v-list-item-title>
            <p>
              {{ formDetails.yacht_detail.gross_tonnage }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Make of engine(s)
            </v-list-item-title>
            <p>
              {{ formDetails.yacht_detail.make_engine }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Engine serial number(s)
            </v-list-item-title>
            <p>
              {{ formDetails.yacht_detail.engine_serialno }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Engine Power of each (h.p.)
            </v-list-item-title>
            <p>
              {{ formDetails.yacht_detail.horse_power }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Maximum designed speed (knots)
            </v-list-item-title>
            <p>
              {{ formDetails.yacht_detail.max_speed }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Type of engine
            </v-list-item-title>
            <p>
              {{
                getDropdownValue(
                  formDetails.yacht_detail.engine_type,
                  "engine_type"
                )
              }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Number of engines
            </v-list-item-title>
            <p>
              {{
                getDropdownValue(
                  formDetails.yacht_detail.engine_number,
                  "engine_number"
                )
              }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Type of fuel used
            </v-list-item-title>
            <p>
              {{
                getDropdownValue(
                  formDetails.yacht_detail.fuel_type,
                  "fuel_type"
                )
              }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Surface drive
            </v-list-item-title>
            <p>
              {{
                getDropdownValue(
                  formDetails.yacht_detail.surface_drive,
                  "radio_button"
                )
              }}
            </p>
          </v-col>
        </v-row>

        <!-- Yacht Usage Section -->

        <v-col cols="12" sm="12" md="12" class="confirm-header header-div">
          <span class="heading-text">Yacht Usage</span>
          <span class="pencil-icon" @click="goToPage(3)"></span>
        </v-col>

        <v-row class="form-item-section">
          <v-col
            cols="12"
            sm="12"
            md="12"
            class="input-wrapper confirm-section"
          >
            <v-list-item-title>
              What is the yacht used for? (You can select multiple options)
            </v-list-item-title>
            <p>
              {{
                getArrayValue(
                  formDetails.yacht_usage.what_used,
                  "yacht_used_for"
                )
              }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Who operates the yacht?
            </v-list-item-title>
            <p>
              {{
                getDropdownValue(
                  formDetails.yacht_usage.who_operates,
                  "yacht_operator"
                )
              }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Years of sailing experience for similar types of yachts
            </v-list-item-title>
            <p>
              {{ formDetails.yacht_usage.years_sailing_experience }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              What cruising range is to be covered?
            </v-list-item-title>
            <p>
              {{
                formDetails.yacht_usage.cruising_range === "OTH"
                  ? formDetails.yacht_usage.cruising_range_desc
                  : getDropdownValue(
                      formDetails.yacht_usage.cruising_range,
                      "cruising_range"
                    )
              }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Mooring type
            </v-list-item-title>
            <p>
              {{
                getDropdownValue(
                  formDetails.yacht_usage.mooring_type,
                  "mooring_type"
                )
              }}
              {{
                formDetails.yacht_usage.mooring_type === "OTH"
                  ? formDetails.yacht_usage.mooring_type_desc
                  : getDropdownValue(
                      formDetails.yacht_usage.mooring_type,
                      "myst_material"
                    )
              }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Where is the yacht usually moored when not in use?
            </v-list-item-title>
            <p>
              {{ formDetails.yacht_usage.where_yacht_moored }}
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            class="input-wrapper confirm-section"
          >
            <v-list-item-title>
              Please give details of moored security and precautions taken
              against the yacht being stolen
            </v-list-item-title>
            <p>
              {{ formDetails.yacht_usage.details_moored_security }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Is yacht fitted with an automatic fire fighting system?
            </v-list-item-title>
            <p>
              {{
                getDropdownValue(
                  formDetails.yacht_usage.is_yacht_fitted_auto_fire_flight,
                  "radio_button"
                )
              }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Has yacht been surveyed by qualified surveyor recently? If so,
              please provide a copy of the report.
            </v-list-item-title>
            <p>
              {{
                getDropdownValue(
                  formDetails.yacht_usage.is_surveyed_by_surveyor,
                  "radio_button"
                )
              }}
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            class="input-wrapper confirm-section"
            v-if="formDetails.yacht_usage.is_surveyed_by_surveyor === 'Y'"
          >
            <v-list-item-title>
              Any copy or document of the report
            </v-list-item-title>
            <p>
              {{
                formDetails.yacht_usage.attachment_yacht_survey[0]
                  ? formDetails.yacht_usage.attachment_yacht_survey[0].file.name
                  : null
              }}
            </p>
          </v-col>
        </v-row>

        <!-- Insured values Section -->

        <v-col cols="12" sm="12" md="12" class="confirm-header header-div">
          <span class="heading-text">Insured Values</span>
          <span class="pencil-icon" @click="goToPage(4)"></span>
        </v-col>

        <v-row class="form-item-section confirm-insured-section">
          <v-col
            cols="12"
            sm="12"
            md="6"
            class="input-wrapper confirm-section currency-div"
          >
            <v-list-item-title>
              Currency
            </v-list-item-title>
            <p class="currency-text">
              {{
                getDropdownValue(
                  formDetails.insured_values.currency,
                  "currency"
                )
              }}
            </p>
          </v-col>

          <v-row class="hr-row md-hidden"></v-row>

          <v-col
            cols="12"
            sm="12"
            md="12"
            class="input-wrapper confirm-section"
          >
            <h3>Hull and equipment including inboard engine (if any)</h3>
          </v-col>
          <v-col cols="12" sm="12" md="4" class="input-wrapper confirm-section">
            <v-list-item-title>
              Purchase Date
            </v-list-item-title>
            <p>
              {{ formDetails.insured_values.purchase_date_hull | moment }}
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="4"
            class="input-wrapper confirm-section confirm-div"
          >
            <v-list-item-title>
              Purchase Price
            </v-list-item-title>
            <p>
              {{ formDetails.insured_values.purchase_price_hull }}
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="4"
            class="input-wrapper confirm-section confirm-div"
          >
            <v-list-item-title>
              Insured Value
            </v-list-item-title>
            <p>
              {{ formDetails.insured_values.insured_value_hull }}
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            class="input-wrapper confirm-section"
          >
            <h3>Dinghy/tender/toys (if any) to the yacht</h3>
          </v-col>
          <v-col cols="12" sm="12" md="4" class="input-wrapper confirm-section">
            <v-list-item-title>
              Purchase Date
            </v-list-item-title>
            <p>
              {{ formDetails.insured_values.purchase_date_dinghy | moment }}
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="4"
            class="input-wrapper confirm-section confirm-div"
          >
            <v-list-item-title>
              Purchase Price
            </v-list-item-title>
            <p>
              {{ formDetails.insured_values.purchase_price_dinghy }}
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="4"
            class="input-wrapper confirm-section confirm-div"
          >
            <v-list-item-title>
              Insured Value
            </v-list-item-title>
            <p>
              {{ formDetails.insured_values.insured_value_dinghy }}
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            class="input-wrapper confirm-section"
          >
            <h3>Personal effects (if any)</h3>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="4"
            class="input-wrapper confirm-section xs-hidden"
          ></v-col>
          <v-col cols="12" sm="12" md="4" class="input-wrapper confirm-section">
            <v-list-item-title>
              Purchase Price
            </v-list-item-title>
            <p>
              {{ formDetails.insured_values.purchase_price_personal_effect }}
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="4"
            class="input-wrapper confirm-section confirm-div"
          >
            <v-list-item-title>
              Insured Value
            </v-list-item-title>
            <p>
              {{ formDetails.insured_values.insured_value_personal_effect }}
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            class="input-wrapper confirm-section"
          >
            <h3>Special equipment (if any)</h3>
          </v-col>
          <v-col cols="12" sm="12" md="4" class="input-wrapper confirm-section">
            <v-list-item-title>
              Purchase Date
            </v-list-item-title>
            <p>
              {{
                formDetails.insured_values.purchase_date_special_equipment
                  | moment
              }}
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="4"
            class="input-wrapper confirm-section confirm-div"
          >
            <v-list-item-title>
              Purchase Price
            </v-list-item-title>
            <p>
              {{ formDetails.insured_values.purchase_price_special_equipment }}
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="4"
            class="input-wrapper confirm-section confirm-div"
          >
            <v-list-item-title>
              Insured Value
            </v-list-item-title>
            <p>
              {{ formDetails.insured_values.insured_value_special_equipment }}
            </p>
          </v-col>

          <v-row class="hr-row total-border" style="margin-top: 20px"></v-row>

          <v-col
            cols="12"
            sm="12"
            md="12"
            class="input-wrapper confirm-section sum-section"
          >
            <v-list-item-title class="bold">
              Total sum to be insured
            </v-list-item-title>
            <p>
              {{ formDetails.insured_values.total }}
            </p>
          </v-col>
        </v-row>

        <!-- Policy details Section -->

        <v-col cols="12" sm="12" md="12" class="confirm-header header-div">
          <span class="heading-text">Policy Details</span>
          <span class="pencil-icon" @click="goToPage(5)"></span>
        </v-col>

        <v-row class="form-item-section">
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Proposed insurance commencing date
            </v-list-item-title>
            <p>
              {{
                formDetails.policy_detail.proposed_insurance_inception_date
                  | moment
              }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Period of insurance
            </v-list-item-title>
            <p>
              12 months
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Type of insurance cover required
            </v-list-item-title>
            <p>
              {{
                getDropdownValue(
                  formDetails.policy_detail.type_of_insurance,
                  "policy_cover_type"
                )
              }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="input-wrapper confirm-section">
            <v-list-item-title>
              Limit of Third Party Liability
            </v-list-item-title>
            <p>
              {{
                getDropdownValue(
                  formDetails.policy_detail.limit_third_party_liability,
                  "liability_required"
                )
              }}
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            class="input-wrapper confirm-section"
            v-if="parseFloat(formDetails.yacht_detail.length) >= 23"
          >
            <v-list-item-title>
              Would you require additional cover? (for yachts longer than 23m in
              length)
            </v-list-item-title>
            <p>
              {{
                formDetails.policy_detail.is_additional_cover_required === 'Y' ? "Yes, full P&I cover required" : "No"
              }}
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            class="input-wrapper confirm-section"
            v-if="formDetails.yacht_detail.yacht_power_type === 'SY'"
          >
            <h3>Coverage - for sailing boat only</h3>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            class="input-wrapper confirm-section"
            v-if="formDetails.yacht_detail.yacht_power_type === 'SY'"
          >
            <v-list-item-title>
              Would cover for masts spars, sails and running riggings against
              racing risks be required?
            </v-list-item-title>
            <p>
              {{
                getDropdownValue(
                  formDetails.policy_detail.is_cover_sails,
                  "radio_button"
                )
              }}
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            class="input-wrapper confirm-section"
            v-if="
              formDetails.yacht_detail.yacht_power_type === 'SY' &&
                formDetails.policy_detail.is_cover_sails === 'Y'
            "
          >
            <v-list-item-title>
              Total Replacement value of these items
            </v-list-item-title>
            <p>
              {{
                getDropdownValue(
                  formDetails.insured_values.currency,
                  "currency"
                )
              }}
              {{ formDetails.policy_detail.cover_sails_replacement_value }}
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            class="input-wrapper confirm-section"
            v-if="formDetails.yacht_detail.yacht_power_type === 'MY'"
          >
            <h3>Coverage - for power boat only</h3>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            class="input-wrapper confirm-section"
            v-if="formDetails.yacht_detail.yacht_power_type === 'MY'"
          >
            <v-list-item-title>
              Would cover for waterskiing, aquaplaning or any similar sport be
              required?
            </v-list-item-title>
            <p>
              {{
                getDropdownValue(
                  formDetails.policy_detail.is_cover_sports,
                  "radio_button"
                )
              }}
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            class="input-wrapper confirm-section"
            v-if="
              formDetails.yacht_detail.yacht_power_type === 'MY' &&
                formDetails.policy_detail.is_cover_sports === 'Y'
            "
          >
            <v-list-item-title>
              Type of activities (e.g. Wake Boarding, doughnuts, banana boats,
              water skiing, etc.)
            </v-list-item-title>
            <p>
              {{ formDetails.policy_detail.cover_sports_type }}
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            class="input-wrapper confirm-section"
            v-if="
              formDetails.yacht_detail.yacht_power_type === 'MY' &&
                formDetails.policy_detail.is_cover_sports === 'Y'
            "
          >
            <v-list-item-title>
              Limit of liability
            </v-list-item-title>
            <p>
              {{
                getDropdownValue(
                  formDetails.policy_detail.limit_liability,
                  "liability_limit"
                )
              }}
            </p>
          </v-col>
        </v-row>

        <!-- Claims record Section -->

        <v-col cols="12" sm="12" md="12" class="confirm-header header-div">
          <span class="heading-text">Claims Record</span>
          <span class="pencil-icon" @click="goToPage(6)"></span>
        </v-col>

        <v-row class="form-item-section">
          <v-col
            cols="12"
            sm="12"
            md="12"
            class="input-wrapper confirm-section"
          >
            <v-list-item-title>
              Any accidents, losses or insurance claims during the past five
              years in connection with any yacht sailed or owned?
            </v-list-item-title>
            <p>
              {{
                getDropdownValue(
                  formDetails.claim_record.is_exist_claim,
                  "radio_button"
                )
              }}
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            class="input-wrapper confirm-section"
            v-if="formDetails.claim_record.is_exist_claim === 'Y'"
          >
            <v-list-item-title>
              Details on accidents, losses or insurance claims
            </v-list-item-title>
            <p>
              {{ formDetails.claim_record.is_exist_claim_desc }}
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            class="input-wrapper confirm-section"
          >
            <v-list-item-title>
              Have you had any yacht insurance declined or cancelled?
            </v-list-item-title>
            <p>
              {{
                getDropdownValue(
                  formDetails.claim_record.is_insurance_declined,
                  "radio_button_have_declined_or_cancelled"
                )
              }}
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            class="input-wrapper confirm-section"
            v-if="formDetails.claim_record.is_insurance_declined === 'Y-D'"
          >
            <v-list-item-title>
              Reason for declining insurance
            </v-list-item-title>
            <p>
              {{ formDetails.claim_record.declined_reason }}
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            class="input-wrapper confirm-section"
            v-if="formDetails.claim_record.is_insurance_declined === 'Y-C'"
          >
            <v-list-item-title>
              Reason for cancelling insurance
            </v-list-item-title>
            <p>
              {{ formDetails.claim_record.cancel_reason }}
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            class="input-wrapper confirm-section"
            v-if="formDetails.claim_record.is_exist_claim !== 'N'"
          >
            <v-list-item-title>
               Please upload claims records or documents
            </v-list-item-title>
            <p>
              {{
                formDetails.claim_record.attachment[0]
                  ? formDetails.claim_record.attachment[0].file.name
                  : null
              }}
            </p>
          </v-col>
        </v-row>
        <v-overlay :opacity="1" v-model="dialog">
          <v-dialog v-model="dialog" persistent>
            <v-card class="info-dialog">
              <h3>You are submitting your proposal form</h3>
              <div
                class="body"
                style="text-align: center; padding-top: 0px; padding-bottom: 30px;"
              >
                Please ensure you have checked that all your information is
                correct. You will not be able to change your details after
                submitting the application.
              </div>
              <div class="footer-section">
                <button
                  class="cancel xs-hidden left"
                  @click="dialog = false"
                  :disabled="showDisabledButton"
                >
                  Change Details
                </button>
                <button
                  class="submit right"
                  @click="validateAndGoNext"
                  :disabled="showDisabledButton"
                >
                  <v-progress-circular
                    :size="20"
                    color="black"
                    indeterminate
                    v-if="showDisabledButton"
                  ></v-progress-circular>
                  <span v-if="!showDisabledButton">Submit Application</span>
                </button>
                <button
                  class="cancel md-hidden right"
                  @click="dialog = false"
                  :disabled="showDisabledButton"
                >
                  Change Details
                </button>
              </div>
            </v-card>
          </v-dialog>
        </v-overlay>

        <v-dialog v-model="errorDialog" persistent class="vue-dialog">
          <v-card class="info-dialog">
            <div class="body">
              <v-card-text class="error-text">
                {{ errorCodeTitle }}
              </v-card-text>
              <v-card-text class="error-text">
                ( ERROR CODE : {{ this.errorCode }} )
              </v-card-text>
              <v-card-text class="error-text" v-if="errorMessage">
                {{ this.errorMessage }}
              </v-card-text>
            </div>
            <div class="footer-section">
              <button @click="errorDialog = !errorDialog" style="width:100%;">
                Ok
              </button>
            </div>
          </v-card>
        </v-dialog>
      </v-container>
    </div>

    <v-col cols="12" class="button-container col-md-8">
      <v-btn
        class="ma-2 form-button cancel submit-button"
        outlined
        color="black"
        @click="goBack"
      >
        <span class="back-icon" style="left: 10px;"></span>
        Previous Step
      </v-btn>
      <v-btn
        class="ma-2 form-button continue right submit-button"
        dark
        color="#F48132"
        @click="dialog = true"
      >
        <span class="submit-text">Submit application</span>
        <span class="next-icon" style="right: 10px;"></span>
      </v-btn>
    </v-col>
  </v-form>
</template>

<script>
import RadialProgressBar from "vue-radial-progress";
import PremiumApi from "@/plugins/axios";
import moment from "moment";

export default {
  components: {
    RadialProgressBar,
  },
  filters: {
    moment: function(date) {
      var result = moment(date).format("DD/MM/YY");
      if (result === "Invalid date") {
        return "";
      } else {
        return moment(date).format("DD/MM/YY");
      }
    },
  },
  data() {
    return {
      valid: false,
      dialog: false,
      completedSteps: 7,
      totalSteps: 7,
      formDetails: this.getFormDetails(),
      errorDialog: false,
      errorCode: null,
      errorCodeTitle: null,
      errorMessage: null,
      showDisabledButton: false,
      insuredIntKeys: [
        "purchase_price_hull",
        "insured_value_hull",
        "purchase_price_dinghy",
        "insured_value_dinghy",
        "purchase_price_personal_effect",
        "insured_value_personal_effect",
        "purchase_price_special_equipment",
        "insured_value_special_equipment",
      ],
      policyDetailsIntKeys: [
        'cover_sails_replacement_value'
      ],
      yachtDetailsIntKeys: [
        'horse_power',
        'gross_tonnage'
      ],
    };
  },
  methods: {
    goBack: function() {
      this.$store.state.formPageNumber = 6;
    },
    goToPage: function(pageNumber) {
      this.$store.state.isEditMode = true;
      this.$store.state.formPageNumber = pageNumber;
    },
    getFormDetails: function() {
      return _.cloneDeep(this.$store.getters.getFormDetails);
    },
    validateAndGoNext: function() {
      this.showDisabledButton = true;
      const postData = _.cloneDeep(this.formDetails);
      this.formatPostData(postData);
      console.log("Form Post Data is " + JSON.stringify(postData));
      let _this = this;
      postData.web_portal = {
        country_code: this.$store.state.country.toUpperCase()
      }
      PremiumApi.postClaim(postData, function(data) {
        let result = data.data.submissionid;
        if (result) {
          _this.$store.dispatch("saveSubmissionId", result);
          _this.$store.state.formPageNumber = 8;
        }
        if (data.request.status >= 400) {
          _this.showErrorDialog(JSON.parse(data.request.response));
        }
        _this.dialog = false;
        _this.showDisabledButton = false;
      });
    },
    formatPostData: function(postData) {
      this.formatCommaNumber(postData.insured_values, this.insuredIntKeys);
      this.formatCommaNumber(postData.policy_detail, this.policyDetailsIntKeys);
      this.formatCommaNumber(postData.yacht_detail, this.yachtDetailsIntKeys);
      postData.claim_record.attachment = this.formatAttachment(postData.claim_record.attachment);
      postData.yacht_usage.attachment_yacht_survey = this.formatAttachment(postData.yacht_usage.attachment_yacht_survey);
    },
    formatCommaNumber: function(obj, parentObj) {
      Object.keys(obj).forEach((key) => {
        if (parentObj.indexOf(key) > -1) {
          obj[key] = !obj[key] ? null : obj[key].replace(/,/g, "");
        }
      });
    },
    showErrorDialog(message) {
      this.errorDialog = true;
      this.errorCode = message.code;
      this.errorCodeTitle = message.message;
      this.errorMessage = message.errordescription;
    },
    getDropdownValue: function(value, dropDownKey) {
      const masterData = _.cloneDeep(this.$store.getters.getMasterList);
      const selectedDropdown = masterData[dropDownKey];
      const obj = selectedDropdown.filter((obj) => {
        return obj.key === value;
      });
      if (obj[0]) {
        return obj[0].value;
      }
      return null;
    },
    getArrayValue: function(array, dropDownKey) {
      const masterData = _.cloneDeep(this.$store.getters.getMasterList);
      const selectedDropdown = masterData[dropDownKey];
      const arr = [];
      selectedDropdown.forEach((obj) => {
        array.forEach((value) => {
          if (obj.key === value) {
            arr.push(obj.value);
          }
        });
      });
      return arr.join(", ");
    },
    formatAttachment: function(attachment) {
      if (attachment.length > 0) {
        return {
          Filename: attachment[0].name,
          Base64string: attachment[0].base64.split(",")[1],
        };
      }
      return {};
    },
    formatAddress: function() {
      const addressObj = [
        this.formDetails.proposer_detail.address2,
        this.formDetails.proposer_detail.address3,
        this.formDetails.proposer_detail.address4,
        this.formDetails.proposer_detail.address5,
      ];
      let address = this.formDetails.proposer_detail.address1;
      addressObj.forEach((e) => {
        if (e) {
          address = address + ", " + e;
        }
      });
      return address;
    },
    trackPage: function() {
      const postData = this.$store.state.accessData;
      postData.url = window.location.href + "/Confirmation";
      PremiumApi.logAccess(postData, function(data) {
        console.log("Data sent with : " + JSON.stringify(postData));
      });
    },
  },
  mounted: function() {
    window.scrollTo(0, 0);
    this.trackPage();
  },
};
</script>
